import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";
import { configManager } from "../utils/ConfigManager";

export default i18next;

export function i18nextInit() {
	const isServer = typeof window === "undefined";

	let basePath = configManager.getConfig("basePath");
	if (!basePath) {
		basePath = "";
	}

	i18next
		.use(initReactI18next)
		.use(HttpApi)
		.init({
			lng: isServer ? "it" : navigator.language.substring(0, 2),
			supportedLngs: ["it", "en"],
			fallbackLng: "it",
			backend: {
				loadPath: basePath + "/locales/{{lng}}/translation.json",
			},
			interpolation: {
				escapeValue: false,
			},
		});
}

export function changeLocalization(isoLang) {
	i18next.changeLanguage(isoLang?.toLowerCase() || navigator.language.substring(0, 2));
}

export function browserLocalization() {
	i18next.changeLanguage(navigator.language.substring(0, 2));
}
